import {
  buildQuoteRequestBody,
  readContactFormHasErrors,
  readContactFormSuccess,
  subscribeCustomerNewsletter,
} from '../utils/shopifyContactForm';

const MIN_PHONE_DIGITS = 10;
const UK_POSTCODE_RE   = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s*[0-9][A-Z]{2}$/i;
const SELECTOR_FORM    = '[data-quote-form]';
const ATTR_QF_INIT     = 'data-qf-init';
const ATTR_QF          = 'data-qf';
const ATTR_ERROR       = 'data-qf-error';

function getField(form, name) {
  return form.querySelector('[' + ATTR_QF + '="' + name + '"]');
}

function setError(form, msg) {
  const el = form.querySelector('[' + ATTR_ERROR + ']');
  el.textContent = msg;
  el.style.display = msg ? 'block' : 'none';
}

function isValidEmail(v)    { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
function isValidPhone(v)    { return (v.match(/\d/g) || []).length >= MIN_PHONE_DIGITS; }
function isValidPostcode(v) { return UK_POSTCODE_RE.test(v.trim()); }

function initForm(form, container) {
  // Mark immediately to prevent double-init or infinite retries.
  // When form.posted_successfully? is true Liquid renders the success state only —
  // there is no [data-quote-form-translations] element and nothing else to wire up.
  container.setAttribute(ATTR_QF_INIT, 'true');

  const translEl = form.querySelector('[data-quote-form-translations]');
  if (!translEl) return;

  const translations = JSON.parse(translEl.textContent);
  const tcEl         = getField(form, 'tc');
  const submitBtn    = getField(form, 'submit');
  const submitArrow  = getField(form, 'submit-arrow');

  function checkReady() {
    const ready = tcEl.checked;
    submitBtn.disabled   = !ready;
    submitArrow.disabled = !ready;
  }

  tcEl.addEventListener('change', checkReady);
  checkReady();

  form.addEventListener('submit', function (e) {
    const company  = getField(form, 'company').value.trim();
    const name     = getField(form, 'name').value.trim();
    const phone    = getField(form, 'phone').value.trim();
    const email    = getField(form, 'email').value.trim();
    const postcode = getField(form, 'postcode').value.trim();
    const message  = getField(form, 'message').value.trim();
    const productCodeEl = getField(form, 'product-code');
    const productCode = productCodeEl ? productCodeEl.value.trim() : '';
    const newsletterEl = getField(form, 'newsletter');

    if (!company)               { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_company); return; }
    if (!name)                  { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_name); return; }
    if (!isValidPhone(phone))   { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_phone); return; }
    if (!isValidEmail(email))   { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_email); return; }
    if (!isValidPostcode(postcode)) { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_postcode); return; }
    if (!message)               { e.preventDefault(); e.stopImmediatePropagation(); setError(form, translations.error_message); return; }

    // Validation passed — let the form submit naturally.
    // Shopify handles CAPTCHA then reloads the page; Liquid shows the success state.
    setError(form, '');
    submitBtn.disabled   = true;
    submitArrow.disabled = true;
  });
}

const initQuoteForm = () => {
  document.querySelectorAll(SELECTOR_FORM + ':not([' + ATTR_QF_INIT + '])').forEach(function (container) {
    const form = container.querySelector('form');
    if (!form) return;
    initForm(form, container);
  });
};

const observer = new MutationObserver(initQuoteForm);
observer.observe(document.body, { childList: true, subtree: true });

export default initQuoteForm;
